import { render, staticRenderFns } from "./PostDialog.vue?vue&type=template&id=3f317fa8&scoped=true&"
import script from "./PostDialog.vue?vue&type=script&lang=js&"
export * from "./PostDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f317fa8",
  null
  
)

export default component.exports